var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneFreeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#282929",
    stroke: "#282929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#282929;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.189,0H151.812C118.96,0,92.328,26.631,92.328,59.484v357.344c0,52.566,42.607,95.172,95.172,95.172H324.5 c52.566,0,95.172-42.607,95.172-95.172V59.484C419.672,26.631,393.042,0,360.189,0z M256,481.229 c-8.115,0-14.688-6.574-14.688-14.688s6.574-14.689,14.688-14.689c8.115,0,14.688,6.574,14.688,14.689S264.115,481.229,256,481.229 z M218.23,22.384h75.532c4.255,0,7.697,3.452,7.697,7.697c0,4.246-3.442,7.697-7.697,7.697H218.23c-4.254,0-7.697-3.45-7.697-7.697 C210.533,25.836,213.976,22.384,218.23,22.384z M125.902,416.828V71.344h260.197v345.483c0,3.844-0.401,7.59-1.074,11.238h-258.05 C126.304,424.418,125.902,420.672,125.902,416.828z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneFreeSvgrepoCom);
export default __webpack_public_path__ + "static/media/smartphone-free-svgrepo-com.b88fc59c142e06dccb608142c0d2c05d.svg";
export { ForwardRef as ReactComponent };